import { render, staticRenderFns } from "./plainTextStyleSelected.vue?vue&type=template&id=51f78032&"
import script from "./plainTextStyleSelected.vue?vue&type=script&lang=ts&"
export * from "./plainTextStyleSelected.vue?vue&type=script&lang=ts&"
import style0 from "./plainTextStyleSelected.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports